//src/services/categories.api.js
const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const getPublicCategories = async () => {
  const res = await fetch(`${API_URL}/categories`);
  if (!res.ok) throw new Error("Failed to load categories");
  return res.json();
};